/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_FreeInputs */

const en_admin_external_booking_edit_free = /** @type {(inputs: Admin_External_Booking_Edit_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

const de_admin_external_booking_edit_free = /** @type {(inputs: Admin_External_Booking_Edit_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlos`)
};

const es_admin_external_booking_edit_free = /** @type {(inputs: Admin_External_Booking_Edit_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const fr_admin_external_booking_edit_free = /** @type {(inputs: Admin_External_Booking_Edit_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratuit`)
};

const nl_admin_external_booking_edit_free = /** @type {(inputs: Admin_External_Booking_Edit_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

/** @type {(inputs: Admin_External_Booking_Edit_FreeInputs) => LocalizedString} */
const it_admin_external_booking_edit_free = en_admin_external_booking_edit_free;

/** @type {(inputs: Admin_External_Booking_Edit_FreeInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_free = en_admin_external_booking_edit_free;

/** @type {(inputs: Admin_External_Booking_Edit_FreeInputs) => LocalizedString} */
const pl_admin_external_booking_edit_free = en_admin_external_booking_edit_free;

/** @type {(inputs: Admin_External_Booking_Edit_FreeInputs) => LocalizedString} */
const hu_admin_external_booking_edit_free = en_admin_external_booking_edit_free;

/** @type {(inputs: Admin_External_Booking_Edit_FreeInputs) => LocalizedString} */
const ro_admin_external_booking_edit_free = en_admin_external_booking_edit_free;

/**
* | output |
* | --- |
* | "Free" |
*
* @param {Admin_External_Booking_Edit_FreeInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_free = /** @type {((inputs?: Admin_External_Booking_Edit_FreeInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_FreeInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_free(inputs)
	if (locale === "de") return de_admin_external_booking_edit_free(inputs)
	if (locale === "es") return es_admin_external_booking_edit_free(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_free(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_free(inputs)
	if (locale === "it") return it_admin_external_booking_edit_free(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_free(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_free(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_free(inputs)
	return ro_admin_external_booking_edit_free(inputs)
});
export { admin_external_booking_edit_free as "admin.external_booking_edit.free" }